export default {
  AppTitle: "AISenses",
  STORAGE: {
    deviceId: "deviceId",
    sheduleConfig: "sheduleConfig",
  },
  PAGES: {
    AUTH: {
      LOGIN: "login",
    },
    HOME: {
      HOME: "home",
      SETTINGS: "settings",
      RECORDINGS: "recordings",
    },
  },
  dateFormat: "dd/mm/yyyy",
  defaultSensorFrequency: 1,
  defaultFrequency: 60,
  oneSecond: 1000,
  oneMinute: 60,
  fiveMinute: 5 * 60 * 1000,
  oneHour: 60 * 60 * 1000,
  defLocale: {
    currency: "USD",
  },
  SHARED: {
    BEARER_TOKEN: "BEARER_TOKEN",
  },
  TOAST_CONFIG: {
    placement: "top-center",
    autoDismissTimeout: 5000,
    autoDismiss: true,
  },
};

export const ToastType = {
  ERROR: "error",
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
};

export const AccelerometerSensor = {
  id: "accelerometer",
  value: "Accelerometer",
  icon: (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none">
      <path d="M19 3.16669L25.3333 9.50002H20.5833V21.9292L30.9225 27.8825L33.25 23.7975L35.625 32.4584L26.9167 34.77L29.3392 30.6375L19 24.6684L8.66083 30.6375L11.0833 34.77L2.375 32.4584L4.75 23.7975L7.0775 27.8825L17.4167 21.9292V9.50002H12.6667L19 3.16669Z" />
    </svg>
  ),
};

export const AbsoluteOrientationSensor = {
  id: "absoluteorientation",
  value: "Orientation Sensor",
  icon: (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none">
      <path d="M19 3.16669L25.3333 9.50002H20.5833V21.9292L30.9225 27.8825L33.25 23.7975L35.625 32.4584L26.9167 34.77L29.3392 30.6375L19 24.6684L8.66083 30.6375L11.0833 34.77L2.375 32.4584L4.75 23.7975L7.0775 27.8825L17.4167 21.9292V9.50002H12.6667L19 3.16669Z" />
    </svg>
  ),
};

export const AmbientLightSensor = {
  id: "ambientlight",
  value: "Light Sensor",
  icon: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38 18.398H36.04C34.934 18.398 34.04 19.116 34.04 20C34.04 20.882 34.934 21.598 36.04 21.598H38C39.104 21.598 40 20.884 40 20C40 19.118 39.102 18.398 38 18.398ZM20 9C18.5542 8.99551 17.1218 9.27697 15.7852 9.82818C14.4486 10.3794 13.2342 11.1895 12.2118 12.2118C11.1895 13.2342 10.3794 14.4486 9.82818 15.7852C9.27697 17.1218 8.99551 18.5542 9 20C9 26.102 13.898 31 20 31C26.1 31 31 26.102 31 20C31 13.898 26.098 9 20 9ZM20 28C15.578 28 12 24.418 12 20C12 15.578 15.578 12 20 12C22.1217 12 24.1566 12.8429 25.6569 14.3431C27.1571 15.8434 28 17.8783 28 20C28 22.1217 27.1571 24.1566 25.6569 25.6569C24.1566 27.1571 22.1217 28 20 28ZM6 20C6 19.118 5.102 18.398 4 18.398H2C0.894 18.398 0 19.116 0 20C0 20.882 0.894 21.598 2 21.598H4C5.102 21.598 6 20.882 6 20ZM20 6C20.882 6 21.598 5.106 21.598 4V2C21.598 0.894 20.882 0 20 0C19.118 0 18.398 0.894 18.398 2V4C18.398 5.106 19.116 6 20 6ZM20 34C19.116 34 18.398 34.894 18.398 36V38C18.398 39.106 19.116 40 20 40C20.882 40 21.598 39.106 21.598 38V36C21.598 34.894 20.882 34 20 34ZM34.73 7.532C35.512 6.75 35.638 5.61 35.014 4.986C34.39 4.362 33.248 4.49 32.47 5.272L31.07 6.67C30.288 7.452 30.162 8.592 30.786 9.216C31.41 9.84 32.552 9.712 33.332 8.93L34.73 7.532ZM6.668 31.066L5.268 32.468C4.486 33.25 4.36 34.386 4.984 35.01C5.608 35.634 6.75 35.51 7.528 34.728L8.928 33.33C9.71 32.548 9.836 31.408 9.212 30.782C8.588 30.156 7.446 30.288 6.668 31.066ZM7.53 5.27C6.75 4.488 5.608 4.36 4.984 4.984C4.36 5.608 4.488 6.75 5.266 7.532L6.666 8.93C7.448 9.712 8.586 9.84 9.21 9.216C9.834 8.592 9.708 7.45 8.928 6.67L7.53 5.27ZM31.068 33.332L32.468 34.73C33.25 35.512 34.388 35.636 35.012 35.016C35.636 34.392 35.51 33.25 34.728 32.47L33.33 31.072C32.548 30.29 31.408 30.162 30.782 30.786C30.156 31.41 30.286 32.55 31.068 33.332Z"
        fill="black"
      />
    </svg>
  ),
};

export const MagnetoMeterSensor = {
  id: "magnetometer",
  value: "Magneto Meter",
  icon: (
    <svg
      width="43"
      height="43"
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="21.5" cy="21.5" r="21.5" fill="#DFDEDE" />
      <path
        d="M21 9.5C19.3585 9.5 17.733 9.82332 16.2165 10.4515C14.6999 11.0797 13.3219 12.0004 12.1612 13.1612C9.81696 15.5054 8.5 18.6848 8.5 22C8.5 25.3152 9.81696 28.4946 12.1612 30.8388C13.3219 31.9996 14.6999 32.9203 16.2165 33.5485C17.733 34.1767 19.3585 34.5 21 34.5C24.3152 34.5 27.4946 33.183 29.8388 30.8388C32.183 28.4946 33.5 25.3152 33.5 22C33.5 20.3585 33.1767 18.733 32.5485 17.2165C31.9203 15.6999 30.9996 14.3219 29.8388 13.1612C28.6781 12.0004 27.3001 11.0797 25.7835 10.4515C24.267 9.82332 22.6415 9.5 21 9.5ZM21 12C23.6522 12 26.1957 13.0536 28.0711 14.9289C29.9464 16.8043 31 19.3478 31 22C31 25 29.75 27.625 27.625 29.5C25.875 27.875 23.5 27 21 27C18.5 27 16.25 27.875 14.375 29.5C12.25 27.625 11 25 11 22C11 19.3478 12.0536 16.8043 13.9289 14.9289C15.8043 13.0536 18.3478 12 21 12ZM23.5 14.3625C23.025 14.375 22.575 14.6875 22.375 15.175L20.7625 19.2125L20.6375 19.5C19.75 19.6625 19.0125 20.25 18.675 21.075C18.1625 22.3625 18.7875 23.8125 20.075 24.325C21.3625 24.8375 22.8125 24.2125 23.325 22.925C23.65 22.1 23.5 21.15 22.9625 20.45L23.0875 20.125L24.7 16.1125L24.7125 16.075C24.9625 15.4375 24.65 14.7125 24.0125 14.45C23.85 14.3875 23.6875 14.3625 23.5 14.3625ZM18.5 14.5C18.1685 14.5 17.8505 14.6317 17.6161 14.8661C17.3817 15.1005 17.25 15.4185 17.25 15.75C17.25 16.0815 17.3817 16.3995 17.6161 16.6339C17.8505 16.8683 18.1685 17 18.5 17C18.8315 17 19.1495 16.8683 19.3839 16.6339C19.6183 16.3995 19.75 16.0815 19.75 15.75C19.75 15.4185 19.6183 15.1005 19.3839 14.8661C19.1495 14.6317 18.8315 14.5 18.5 14.5ZM14.75 18.25C14.4185 18.25 14.1005 18.3817 13.8661 18.6161C13.6317 18.8505 13.5 19.1685 13.5 19.5C13.5 19.8315 13.6317 20.1495 13.8661 20.3839C14.1005 20.6183 14.4185 20.75 14.75 20.75C15.0815 20.75 15.3995 20.6183 15.6339 20.3839C15.8683 20.1495 16 19.8315 16 19.5C16 19.1685 15.8683 18.8505 15.6339 18.6161C15.3995 18.3817 15.0815 18.25 14.75 18.25ZM27.25 18.25C26.9185 18.25 26.6005 18.3817 26.3661 18.6161C26.1317 18.8505 26 19.1685 26 19.5C26 19.8315 26.1317 20.1495 26.3661 20.3839C26.6005 20.6183 26.9185 20.75 27.25 20.75C27.5815 20.75 27.8995 20.6183 28.1339 20.3839C28.3683 20.1495 28.5 19.8315 28.5 19.5C28.5 19.1685 28.3683 18.8505 28.1339 18.6161C27.8995 18.3817 27.5815 18.25 27.25 18.25Z"
        fill="black"
      />
    </svg>
  ),
};

export const MicrophoneSensor = {
  id: "microphone",
  value: "Microphone",
  icon: (
    <svg width="38" height="38" viewBox="0 0 40 40" fill="none">
      <path d="M24.4492 4.49219C24.2188 4.49219 23.9844 4.55469 23.7695 4.69922L9.92188 13.75H3.51562C3.17187 13.75 2.89062 14.0312 2.89062 14.375V25.625C2.89062 25.9688 3.17187 26.25 3.51562 26.25H9.92188L23.7695 35.3008C23.9844 35.4414 24.2227 35.5078 24.4492 35.5078C25.1016 35.5078 25.7031 34.9883 25.7031 34.2539V5.74609C25.7031 5.01172 25.1016 4.49219 24.4492 4.49219ZM22.8906 31.3672L11.4609 23.8945L10.7578 23.4375H5.70312V16.5625H10.7578L11.457 16.1055L22.8906 8.63281V31.3672ZM36.4844 18.5938H31.4844C31.1406 18.5938 30.8594 18.875 30.8594 19.2188V20.7812C30.8594 21.125 31.1406 21.4062 31.4844 21.4062H36.4844C36.8281 21.4062 37.1094 21.125 37.1094 20.7812V19.2188C37.1094 18.875 36.8281 18.5938 36.4844 18.5938ZM34.8477 28.8203L30.5391 26.332C30.4683 26.2915 30.3902 26.2653 30.3093 26.255C30.2284 26.2446 30.1462 26.2503 30.0675 26.2717C29.9888 26.2931 29.9151 26.3298 29.8505 26.3797C29.786 26.4296 29.7319 26.4917 29.6914 26.5625L28.9141 27.9102C28.7422 28.207 28.8438 28.5898 29.1406 28.7617L33.4492 31.25C33.52 31.2905 33.5981 31.3167 33.679 31.3271C33.7599 31.3374 33.8421 31.3317 33.9208 31.3103C33.9995 31.2889 34.0732 31.2522 34.1378 31.2023C34.2023 31.1524 34.2564 31.0903 34.2969 31.0195L35.0742 29.6719C35.2461 29.375 35.1406 28.9922 34.8477 28.8203ZM29.6875 13.4375C29.728 13.5083 29.7821 13.5704 29.8466 13.6203C29.9112 13.6702 29.9849 13.7069 30.0636 13.7283C30.1423 13.7497 30.2245 13.7554 30.3054 13.745C30.3863 13.7347 30.4644 13.7085 30.5352 13.668L34.8438 11.1797C35.1406 11.0078 35.2422 10.625 35.0703 10.3281L34.2969 8.98438C34.2564 8.91358 34.2023 8.85146 34.1378 8.80156C34.0732 8.75166 33.9995 8.71497 33.9208 8.69357C33.8421 8.67216 33.7599 8.66648 33.679 8.67683C33.5981 8.68718 33.52 8.71337 33.4492 8.75391L29.1406 11.2422C28.998 11.3254 28.894 11.4616 28.8516 11.6212C28.8091 11.7808 28.8316 11.9507 28.9141 12.0938L29.6875 13.4375Z" />
    </svg>
  ),
};

export const CameraSensor = {
  id: "camera",
  value: "Camera",
  icon: (
    <svg width="38" height="38" viewBox="0 0 36 37" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 9.5C3 8.30653 3.47411 7.16193 4.31802 6.31802C5.16193 5.47411 6.30653 5 7.5 5H28.5C29.6935 5 30.8381 5.47411 31.682 6.31802C32.5259 7.16193 33 8.30653 33 9.5V27.5C33 28.6935 32.5259 29.8381 31.682 30.682C30.8381 31.5259 29.6935 32 28.5 32H7.5C6.30653 32 5.16193 31.5259 4.31802 30.682C3.47411 29.8381 3 28.6935 3 27.5V9.5ZM7.5 8C7.10218 8 6.72065 8.15804 6.43934 8.43934C6.15804 8.72064 6 9.10218 6 9.5V27.5C6 27.8978 6.15804 28.2794 6.43934 28.5607C6.72065 28.842 7.10218 29 7.5 29H28.5C28.8978 29 29.2794 28.842 29.5607 28.5607C29.842 28.2794 30 27.8978 30 27.5V9.5C30 9.10218 29.842 8.72064 29.5607 8.43934C29.2794 8.15804 28.8978 8 28.5 8H7.5ZM24 11C24 10.6022 24.158 10.2206 24.4393 9.93934C24.7206 9.65804 25.1022 9.5 25.5 9.5H27C27.3978 9.5 27.7794 9.65804 28.0607 9.93934C28.342 10.2206 28.5 10.6022 28.5 11C28.5 11.3978 28.342 11.7794 28.0607 12.0607C27.7794 12.342 27.3978 12.5 27 12.5H25.5C25.1022 12.5 24.7206 12.342 24.4393 12.0607C24.158 11.7794 24 11.3978 24 11ZM13.5 18.5C13.5 17.3065 13.9741 16.1619 14.818 15.318C15.6619 14.4741 16.8065 14 18 14C19.1935 14 20.3381 14.4741 21.182 15.318C22.0259 16.1619 22.5 17.3065 22.5 18.5C22.5 19.6935 22.0259 20.8381 21.182 21.682C20.3381 22.5259 19.1935 23 18 23C16.8065 23 15.6619 22.5259 14.818 21.682C13.9741 20.8381 13.5 19.6935 13.5 18.5ZM18 11C16.0109 11 14.1032 11.7902 12.6967 13.1967C11.2902 14.6032 10.5 16.5109 10.5 18.5C10.5 20.4891 11.2902 22.3968 12.6967 23.8033C14.1032 25.2098 16.0109 26 18 26C19.9891 26 21.8968 25.2098 23.3033 23.8033C24.7098 22.3968 25.5 20.4891 25.5 18.5C25.5 16.5109 24.7098 14.6032 23.3033 13.1967C21.8968 11.7902 19.9891 11 18 11Z"
      />
    </svg>
  ),
};

export const BatterySensor = {
  id: "battery",
  value: "Battery",
  icon: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99998 25C9.55795 25 9.13403 24.8244 8.82147 24.5118C8.50891 24.1993 8.33331 23.7754 8.33331 23.3333V16.6667C8.33331 16.2246 8.50891 15.8007 8.82147 15.4882C9.13403 15.1756 9.55795 15 9.99998 15H20V25H9.99998Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 10H8.33331C7.00723 10 5.73546 10.5268 4.79778 11.4645C3.8601 12.4021 3.33331 13.6739 3.33331 15V25C3.33331 26.3261 3.8601 27.5979 4.79778 28.5355C5.73546 29.4732 7.00723 30 8.33331 30H30C31.3261 30 32.5978 29.4732 33.5355 28.5355C34.4732 27.5979 35 26.3261 35 25C35.442 25 35.8659 24.8244 36.1785 24.5118C36.4911 24.1993 36.6666 23.7754 36.6666 23.3333V16.6667C36.6666 16.2246 36.4911 15.8007 36.1785 15.4882C35.8659 15.1756 35.442 15 35 15C35 13.6739 34.4732 12.4021 33.5355 11.4645C32.5978 10.5268 31.3261 10 30 10ZM30 13.3333H8.33331C7.89129 13.3333 7.46736 13.5089 7.1548 13.8215C6.84224 14.134 6.66665 14.558 6.66665 15V25C6.66665 25.442 6.84224 25.8659 7.1548 26.1785C7.46736 26.4911 7.89129 26.6667 8.33331 26.6667H30C30.442 26.6667 30.8659 26.4911 31.1785 26.1785C31.4911 25.8659 31.6666 25.442 31.6666 25V15C31.6666 14.558 31.4911 14.134 31.1785 13.8215C30.8659 13.5089 30.442 13.3333 30 13.3333Z"
        fill="black"
      />
    </svg>
  ),
};

export const BluetoothSensor = {
  id: "bluetooth",
  value: "Bluetooth",
  icon: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99998 25C9.55795 25 9.13403 24.8244 8.82147 24.5118C8.50891 24.1993 8.33331 23.7754 8.33331 23.3333V16.6667C8.33331 16.2246 8.50891 15.8007 8.82147 15.4882C9.13403 15.1756 9.55795 15 9.99998 15H20V25H9.99998Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 10H8.33331C7.00723 10 5.73546 10.5268 4.79778 11.4645C3.8601 12.4021 3.33331 13.6739 3.33331 15V25C3.33331 26.3261 3.8601 27.5979 4.79778 28.5355C5.73546 29.4732 7.00723 30 8.33331 30H30C31.3261 30 32.5978 29.4732 33.5355 28.5355C34.4732 27.5979 35 26.3261 35 25C35.442 25 35.8659 24.8244 36.1785 24.5118C36.4911 24.1993 36.6666 23.7754 36.6666 23.3333V16.6667C36.6666 16.2246 36.4911 15.8007 36.1785 15.4882C35.8659 15.1756 35.442 15 35 15C35 13.6739 34.4732 12.4021 33.5355 11.4645C32.5978 10.5268 31.3261 10 30 10ZM30 13.3333H8.33331C7.89129 13.3333 7.46736 13.5089 7.1548 13.8215C6.84224 14.134 6.66665 14.558 6.66665 15V25C6.66665 25.442 6.84224 25.8659 7.1548 26.1785C7.46736 26.4911 7.89129 26.6667 8.33331 26.6667H30C30.442 26.6667 30.8659 26.4911 31.1785 26.1785C31.4911 25.8659 31.6666 25.442 31.6666 25V15C31.6666 14.558 31.4911 14.134 31.1785 13.8215C30.8659 13.5089 30.442 13.3333 30 13.3333Z"
        fill="black"
      />
    </svg>
  ),
};

export const GeoLocationSensor = {
  id: "location",
  value: "Location",
  icon: (
    <svg width="38" height="38" viewBox="0 0 41 41" fill="none">
      <path d="M20.5 5.12504C17.3285 5.12504 14.2868 6.38493 12.0442 8.62755C9.80156 10.8702 8.54167 13.9118 8.54167 17.0834C8.54167 21.9726 11.5859 26.6893 14.9274 30.3435C16.636 32.2049 18.5003 33.9172 20.5 35.4616C20.7984 35.2327 21.1486 34.9537 21.5506 34.6245C23.1561 33.3062 24.6672 31.8768 26.0726 30.3469C29.4141 26.6893 32.4583 21.9743 32.4583 17.0834C32.4583 13.9118 31.1984 10.8702 28.9558 8.62755C26.7132 6.38493 23.6715 5.12504 20.5 5.12504ZM20.5 39.6573L19.5314 38.991L19.5263 38.9876L19.516 38.9791L19.4818 38.9552L19.3537 38.8646L18.8925 38.5281C16.5552 36.7715 14.384 34.8044 12.4059 32.6514C8.91408 28.8282 5.125 23.2949 5.125 17.0817C5.125 13.004 6.74486 9.09327 9.62823 6.2099C12.5116 3.32653 16.4223 1.70667 20.5 1.70667C24.5777 1.70667 28.4884 3.32653 31.3718 6.2099C34.2551 9.09327 35.875 13.004 35.875 17.0817C35.875 23.2949 32.0859 28.8299 28.5941 32.648C26.6166 34.8009 24.4459 36.768 22.1093 38.5247C21.9146 38.6701 21.7181 38.813 21.5199 38.9535L21.484 38.9774L21.4737 38.9859L21.4703 38.9876L20.5 39.6573ZM20.5 13.6667C19.5938 13.6667 18.7248 14.0267 18.0841 14.6674C17.4433 15.3082 17.0833 16.1772 17.0833 17.0834C17.0833 17.9895 17.4433 18.8586 18.0841 19.4993C18.7248 20.1401 19.5938 20.5 20.5 20.5C21.4062 20.5 22.2752 20.1401 22.9159 19.4993C23.5567 18.8586 23.9167 17.9895 23.9167 17.0834C23.9167 16.1772 23.5567 15.3082 22.9159 14.6674C22.2752 14.0267 21.4062 13.6667 20.5 13.6667ZM13.6667 17.0834C13.6667 15.2711 14.3866 13.533 15.6681 12.2515C16.9496 10.97 18.6877 10.25 20.5 10.25C22.3123 10.25 24.0504 10.97 25.3319 12.2515C26.6134 13.533 27.3333 15.2711 27.3333 17.0834C27.3333 18.8957 26.6134 20.6338 25.3319 21.9153C24.0504 23.1968 22.3123 23.9167 20.5 23.9167C18.6877 23.9167 16.9496 23.1968 15.6681 21.9153C14.3866 20.6338 13.6667 18.8957 13.6667 17.0834Z" />
    </svg>
  ),
};

export const GyroscopeSensor = {
  id: "gyroscope",
  value: "Gyroscope",
  icon: (
    <svg
      width="43"
      height="43"
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="21.5" cy="21.5" r="21.5" fill="#DFDEDE" />
      <path
        d="M21 9.5C19.3585 9.5 17.733 9.82332 16.2165 10.4515C14.6999 11.0797 13.3219 12.0004 12.1612 13.1612C9.81696 15.5054 8.5 18.6848 8.5 22C8.5 25.3152 9.81696 28.4946 12.1612 30.8388C13.3219 31.9996 14.6999 32.9203 16.2165 33.5485C17.733 34.1767 19.3585 34.5 21 34.5C24.3152 34.5 27.4946 33.183 29.8388 30.8388C32.183 28.4946 33.5 25.3152 33.5 22C33.5 20.3585 33.1767 18.733 32.5485 17.2165C31.9203 15.6999 30.9996 14.3219 29.8388 13.1612C28.6781 12.0004 27.3001 11.0797 25.7835 10.4515C24.267 9.82332 22.6415 9.5 21 9.5ZM21 12C23.6522 12 26.1957 13.0536 28.0711 14.9289C29.9464 16.8043 31 19.3478 31 22C31 25 29.75 27.625 27.625 29.5C25.875 27.875 23.5 27 21 27C18.5 27 16.25 27.875 14.375 29.5C12.25 27.625 11 25 11 22C11 19.3478 12.0536 16.8043 13.9289 14.9289C15.8043 13.0536 18.3478 12 21 12ZM23.5 14.3625C23.025 14.375 22.575 14.6875 22.375 15.175L20.7625 19.2125L20.6375 19.5C19.75 19.6625 19.0125 20.25 18.675 21.075C18.1625 22.3625 18.7875 23.8125 20.075 24.325C21.3625 24.8375 22.8125 24.2125 23.325 22.925C23.65 22.1 23.5 21.15 22.9625 20.45L23.0875 20.125L24.7 16.1125L24.7125 16.075C24.9625 15.4375 24.65 14.7125 24.0125 14.45C23.85 14.3875 23.6875 14.3625 23.5 14.3625ZM18.5 14.5C18.1685 14.5 17.8505 14.6317 17.6161 14.8661C17.3817 15.1005 17.25 15.4185 17.25 15.75C17.25 16.0815 17.3817 16.3995 17.6161 16.6339C17.8505 16.8683 18.1685 17 18.5 17C18.8315 17 19.1495 16.8683 19.3839 16.6339C19.6183 16.3995 19.75 16.0815 19.75 15.75C19.75 15.4185 19.6183 15.1005 19.3839 14.8661C19.1495 14.6317 18.8315 14.5 18.5 14.5ZM14.75 18.25C14.4185 18.25 14.1005 18.3817 13.8661 18.6161C13.6317 18.8505 13.5 19.1685 13.5 19.5C13.5 19.8315 13.6317 20.1495 13.8661 20.3839C14.1005 20.6183 14.4185 20.75 14.75 20.75C15.0815 20.75 15.3995 20.6183 15.6339 20.3839C15.8683 20.1495 16 19.8315 16 19.5C16 19.1685 15.8683 18.8505 15.6339 18.6161C15.3995 18.3817 15.0815 18.25 14.75 18.25ZM27.25 18.25C26.9185 18.25 26.6005 18.3817 26.3661 18.6161C26.1317 18.8505 26 19.1685 26 19.5C26 19.8315 26.1317 20.1495 26.3661 20.3839C26.6005 20.6183 26.9185 20.75 27.25 20.75C27.5815 20.75 27.8995 20.6183 28.1339 20.3839C28.3683 20.1495 28.5 19.8315 28.5 19.5C28.5 19.1685 28.3683 18.8505 28.1339 18.6161C27.8995 18.3817 27.5815 18.25 27.25 18.25Z"
        fill="black"
      />
    </svg>
  ),
};

export const SensorType = {
  Accelerometer: "Accelerometer",
  AmbientLightSensor: "AmbientLightSensor",
  GravitySensor: "GravitySensor",
  Gyroscope: "Gyroscope",
  LinearAccelerationSensor: "LinearAccelerationSensor",
  Magnetometer: "Magnetometer",
  AbsoluteOrientationSensor: "AbsoluteOrientationSensor",
  RelativeOrientationSensor: "RelativeOrientationSensor",
};

export const SOCKET = {
  CONNECTED: "CONNECTED",
  DISCONNECTED: "DISCONNECTED",
};

export const WeekDays = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
};

export const WeekNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
